import { ValidationResult } from "lib/hooks/use-input";

export type Validator<T> = (v: T) => ValidationResult;

export const useValidators = <T>(
  validators: Array<Validator<T>>
): Validator<T> => {
  return (v: any) => {
    for (let index = 0; index < validators.length; index++) {
      let validationResult = validators[index](v);

      if (!validationResult.valid) {
        return validationResult;
      }
    }
    return { valid: true };
  };
};
